import * as angular from 'angular';

import { TableListCellRenderMethod } from '../table-list-cell-render-method/table-list-cell-render-method.type';
import { TableListValue, TableListValueType } from '../lib/table-list-value';

class TableListCellController {
  private column!: string;
  private tooltip!: string;
  private value!: TableListValue;
  private renderMethod!: TableListCellRenderMethod;
  private displayTooltip!: boolean;

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes['tooltip']) {
      this.displayTooltip = changes['tooltip'].currentValue && changes['tooltip'].currentValue.length;
    }

    if (changes['value']) {
      this.handleValueChange(changes['value'].currentValue);
    }
  }

  handleValueChange(value: TableListValue) {
    if (value) {
      switch (value.type) {
        case TableListValueType.Avatar:
          this.renderMethod = TableListCellRenderMethod.Avatar;
          break;
        case TableListValueType.Text:
          this.renderMethod = TableListCellRenderMethod.Text;
          break;
        case TableListValueType.Html:
          this.renderMethod = TableListCellRenderMethod.Html;
          break;
        case TableListValueType.Icon:
          this.renderMethod = TableListCellRenderMethod.Icon;
          break;
        case TableListValueType.BadgeWithText:
          this.renderMethod = TableListCellRenderMethod.BadgeWithText;
          break;
        default:
          this.renderMethod = TableListCellRenderMethod.Transclude;
          break;
      }
    } else {
      this.renderMethod = TableListCellRenderMethod.Transclude;
    }
  }

  methodIs(method: TableListCellRenderMethod) {
    return this.renderMethod === method;
  }
}

export const TableListCellComponent: angular.IComponentOptions = {
  controller: TableListCellController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    column: '@',
    tooltip: '<',
    value: '<',
  },
  template: `
    <table-list-cell-content
      ng-if="ctrl.displayTooltip"
      column="ctrl.column"
      render-method="ctrl.renderMethod"
      tooltip-class="wrapping-tooltip-lg"
      tooltip-placement="bottom"
      tooltip-popup-delay="500"
      uib-tooltip="{{ctrl.tooltip}}"
      value="ctrl.value"
    />
    <table-list-cell-content
      ng-if="!ctrl.displayTooltip"
      column="ctrl.column"
      render-method="ctrl.renderMethod"
      value="ctrl.value"
    >
      <ng-transclude ng-if="ctrl.methodIs('${TableListCellRenderMethod.Transclude}')"></ng-transclude>
    </table-list-cell-content>
  `,
};
